import { render, staticRenderFns } from "./unit-zifuchuan.vue?vue&type=template&id=eff9624e"
import script from "./unit-zifuchuan.vue?vue&type=script&lang=ts"
export * from "./unit-zifuchuan.vue?vue&type=script&lang=ts"
import style0 from "./unit-zifuchuan.vue?vue&type=style&index=0&id=eff9624e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports